import React from 'react'
import { CircleSpinner } from 'react-spinners-kit'
import { RelatorioParametroType } from '../types'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableContainer from '@mui/material/TableContainer'

interface Props {
    lista: RelatorioParametroType[] | null
    loading: boolean
}

const TableListarRelatorio: React.FC<Props> = ({ lista, loading }) => {

    const SHOW_DATA = !!lista && !loading && lista.length>0
    const SHOW_LOADING = loading
    const [selectedLine, setSelectedLine] = React.useState<any | null>(null)
    return (

        <TableContainer sx={{ maxHeight: 640 }}>
            <Table stickyHeader aria-label="sticky table">
                                
                <TableHead >
                    <TableRow >
                        {SHOW_DATA && [ "Parâmetros Analisados", "Quantidade de ensaios", "Conformes", "Não Conformes"].map((column, index) => <TableCell key={index}  > {column}</TableCell>)}
                    </TableRow>
                </TableHead>

                <TableBody >
                    {SHOW_LOADING && (
                        <TableRow >
                            <TableCell>
                                <div className = "center">
                                    <CircleSpinner size = {32} color = "grey" />
                                </div></TableCell>
                        </TableRow>
                    )}
                    {SHOW_DATA && lista.map((item, index) => (
                        <TableRow key={index} className = {selectedLine?.id === item.id ? 'selected' : ''} onClick = {() => setSelectedLine(item)}>
                            <TableCell  ><div style={{ textAlign: "left" }}>{item.descricao}</div> </TableCell>
                            <TableCell  >{(item.qtde.toString())}</TableCell>
                            <TableCell  >{(item.qtdeConforme.toString())}</TableCell>
                            <TableCell  > {(item.qtdeNaoConforme.toString())}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            
        </TableContainer>
    )

}

export default TableListarRelatorio